import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import { Document, Page, pdfjs } from 'react-pdf';

import coverImg from '../imgs/tfk_background.png';
import { PageContainer } from '../styles/pages.css';
import { GlobalStyle } from '../styles/common.css';
import mypdf from "../files/tfk-privacy.pdf";

const isBrowser = typeof window !== "undefined"

export default () => {
  const [numPages, setNumPages] = useState(null);
  const [windowWidth, setWindowWidth] = useState(440);

  useEffect(() => {
    if (isBrowser) {
      pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
      setWindowWidth(window.innerWidth);
    }

    const handleResize = () => {
      if (isBrowser) {
        setWindowWidth(window.innerWidth);
      }
    };

    if (isBrowser) {
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (isBrowser) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  }

  const calculaePdfWidth = () => {
    if (windowWidth <= 440) {
        return windowWidth * 0.85;;
    }

    if (windowWidth > 850) {
      return 850;
    }

    return windowWidth;
  }

  return (
    <>
      <GlobalStyle />
      <PageContainer>
        
        <img className="cover" src={coverImg} alt="" />
        <div className="pdf-content">
          <Link to="/"> ⬅ Back</Link>
          <div className="pdf-wrapper" style={{ width: calculaePdfWidth() }}>
            {isBrowser === true &&
              <Document file={mypdf} onLoadSuccess={onDocumentLoadSuccess} >
                {[...Array(numPages)].map((_, index) => (

                  <Page pageNumber={index + 1}
                    key={(index)}
                    renderAnnotationLayer={false}
                    renderMode="svg"
                    className="page"
                    width={calculaePdfWidth()
                    }
                  />
                ))}
              </Document>
            }
          </div>
        </div>

      </PageContainer>
    </>
  );
};
